import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=5d32c9a8"
import script from "./CalendarCard.vue?vue&type=script&lang=js"
export * from "./CalendarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports